var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.SuchbegriffGross)?_c('div',[(this.$store.getters.fetchSuchbegriff)?_c('span',{staticClass:"title text-truncate"},[_c('v-icon',[_vm._v("keyboard_arrow_right")]),_vm._v("\n      "+_vm._s(_vm.SuchbegriffGross)+" in "+_vm._s(_vm.StadtNameGross)+" "+_vm._s(_vm.PLZ)+"\n    ")],1):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }